import { render, staticRenderFns } from "./vSelectEstadoCivil.vue?vue&type=template&id=68b0e10c&scoped=true&"
import script from "./vSelectEstadoCivil.vue?vue&type=script&lang=js&"
export * from "./vSelectEstadoCivil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0e10c",
  null
  
)

export default component.exports